SJ.playerData = {};

SJ.playerData.data = {};

SJ.playerData.checkPlayerDataInSessionStorage = (callback) => {
	SJ.playerData.setDefault();
	const playerName = sessionStorage.getItem('playername');
	const playerPassword = sessionStorage.getItem('playerpassword');

	fetch(
		`${SJ.APILink}user/checkPassword.php?&userName=${playerName}&password=${playerPassword}`
	)
		.then((res) => res.json())
		.then((res) => {
			if (res === 'correct') {
				// console.log('');
				// console.log('Password and username correctly read');
				SJ.playerData.getUserData(playerName, playerPassword, callback);
			} else {
				console.log('Password and username read error');
				callback();
			}
		});
};

SJ.playerData.getUserData = (name, password, callback) => {
	// console.log('Start user data load');
	fetch(`${SJ.APILink}user/getByName.php?name=${name}&password=${password}`)
		.then((response) => response.json())
		.then(function (jsonResponse) {
			jsonResponse = jsonResponse[0];
			if (jsonResponse) {
				SJ.playerData.data['name'] = jsonResponse['name'];
				SJ.playerData.data['money'] = parseInt(jsonResponse['money']);

				SJ.playerData.data['VIPmoney'] = parseInt(jsonResponse['VIPmoney']);

				SJ.playerData.data['mapGlobalRankingScore'] = parseFloat(
					jsonResponse['mapGlobalRankingScore']
				);
				SJ.playerData.data['tournamentRankingScore'] = parseFloat(
					jsonResponse['tournamentRankingScore']
				);

				SJ.playerData.data['mapGlobalRankingRank'] =
					jsonResponse['mapGlobalRankingRank'];

				SJ.playerData.data['vipAccountTimestamp'] =
					jsonResponse['vipAccountExpirationTime'];

				SJ.playerData.data['worldcupDailyJumpsCount'] =
					jsonResponse['worldcupDailyJumpsCount'];

				SJ.playerData.data['tournamentDailyJumpsCount'] =
					jsonResponse['tournamentDailyJumpsCount'];

				SJ.playerData.data['successfulJumps'] = parseInt(
					jsonResponse['successfulJumps']
				);

				SJ.playerData.data['lastBuyTimeOfWorldcupJumps'] = parseInt(
					jsonResponse['lastBuyTimeOfWorldcupJumps']
				);
				SJ.playerData.data['lastBuyTimeOfTournamentJumps'] = parseInt(
					jsonResponse['lastBuyTimeOfTournamentJumps']
				);

				SJ.playerData.data['moneySpent'] = parseInt(jsonResponse['moneySpent']);
				SJ.playerData.data['finishedTournaments'] = parseInt(
					jsonResponse['finishedTournaments']
				);
				SJ.playerData.data['VIPmoneySpent'] = parseInt(
					jsonResponse['VIPmoneySpent']
				);
				SJ.playerData.data['isTutorialFinished'] = parseInt(
					jsonResponse['isTutorialFinished']
				);
				SJ.playerData.data['boostedItem'] = jsonResponse['boostedItem'];

				SJ.playerData.data['dailyBonus'] = parseInt(jsonResponse['dailyBonus']);

				SJ.playerData.data['beenEverJumping'] = parseInt(
					jsonResponse['beenEverJumping']
				);

				// console.log('User data loaded');
				// console.log(`Player set to: ${SJ.playerData.data['name']}`);
				// console.log('Player data:', SJ.playerData.data);

				SJ.playerData.updatePlayerRankPosition();

				SJ.playerData.checkDatabaseCohesion(jsonResponse['name'], callback);

				SJ.playerData.checkIfVipAccountActive();

				SJ.playerData.getSettings();

				SJ.playerData.checkIfPaymentNotifications();
			} else {
				callback();
			}
		})
		.catch((error) => {
			console.log(`Get player name error: ${error}`);
		});
};

SJ.playerData.getSettings = () => {
	if (SJ.playerData.data['name'] === 'Guest') return;

	fetch(
		`${SJ.APILink}settings/getAll.php?userName=${SJ.playerData.data['name']}`
	)
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			res = res[0];

			SJ.settings.graphic = res.graphic;
			SJ.settings.framerate = parseInt(res.fps);
			SJ.settings.SFX = res.SFX === '1' ? true : false;
			SJ.settings.menuSFX = res.menuSFX === '1' ? true : false;
			SJ.settings.music = res.music === '1' ? true : false;

			// console.log('Player settings:', SJ.settings);

			frameRate(parseInt(SJ.settings.framerate));

			if (!SJ.settings.music && SJ.mainSoundtrack) {
				SJ.mainSoundtrack.pause();
				SJ.mainSoundtrack.autoPlay = false;
			}

			if (!SJ.settings.SFX) {
				SJ.SFXSoundManager.lockPlaying();
				SJ.SFXSoundManager.pause();
			} else {
				SJ.SFXSoundManager.unlockPlaying();
			}

			if (!SJ.settings.menuSFX) {
				SJ.mainMenuSoundContainer.lockPlaying();
				SJ.mainMenuSoundContainer.pause();
			} else {
				SJ.mainMenuSoundContainer.unlockPlaying();
			}
		});
};

SJ.playerData.setDefault = () => {
	SJ.playerData.data = {
		name: 'Guest',
		money: 75000,
		VIPmoney: 0,
		mapGlobalRankingScore: 0.0,
		mapGlobalRankingRank: 'Junior',
		mapGlobalRankingPosition: 0,
		tournamentRankingScore: 0.0,
		tournamentRankingPosition: 0,
		vipAccountExpirationTime: 0,
		isVip: false,
		worldcupDailyJumpsCount: 0,
		tournamentDailyJumpsCount: 0,
		successfulJumps: 0,
		lastBuyTimeOfWorldcupJumps: 0,
		lastBuyTimeOfTournamentJumps: 0,
		moneySpent: 0,
		finishedTournaments: 0,
		VIPmoneySpent: 0,
		isTutorialFinished: 0,
		boostedItem: '',
		dailyBonus: 0,
		beenEverJumping: 0,
	};
};

SJ.playerData.setCurrentMapRecords = (mapName) => {
	let url = `${SJ.APILink}user/getMapRecords.php?userName=${SJ.playerData.data['name']}&mapName=${mapName}`;

	fetch(url)
		.then(function (response) {
			return response.json();
		})
		.then(function (jsonResponse) {
			jsonResponse = jsonResponse[0];
			if (jsonResponse) {
				SJ.playerData.data['currentMapDistanceRecord'] = parseFloat(
					jsonResponse['jumpDistance']
				);
				SJ.playerData.data['currentMapScoreRecord'] = parseFloat(
					jsonResponse['jumpScore']
				);
			}
		})
		.catch((error) => {
			console.log(`Get player name error: ${error}`);
		});
};

SJ.playerData.checkDatabaseCohesion = (userName, callback) => {
	// console.log('Start database cohesion check');
	let url = `${SJ.APILink}user/checkDatabaseCohesion.php?userName=${userName}`;
	fetch(url).then(() => {
		callback();
		// console.log('Database cohesion check finished');
	});
};

SJ.playerData.checkIfVipAccountActive = (callback) => {
	// console.log('Start checking VIP account');

	const curTimeStamp = round(Date.now() / 1000);

	fetch(
		`${SJ.APILink}user/getVipAccountExpirationTime.php?userName=${SJ.playerData.data['name']}`
	)
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			if (parseInt(res) > curTimeStamp) {
				SJ.playerData.data['isVip'] = true;
				SJ.playerData.data['vipAccountExpirationTime'] = parseInt(res);

				// console.log(
				//   `Player has VIP account to ${SJ.playerData.getVipAccountExpirationDate()}`
				// );
			}

			if (callback) {
				callback();
			}
		});
};

SJ.playerData.getVipAccountExpirationDate = () => {
	const UNIXTimestampToDate = (UNIX_timestamp) => {
		const d = new Date(UNIX_timestamp * 1000);
		return `${d.toLocaleString()}`;
	};

	return UNIXTimestampToDate(SJ.playerData.data['vipAccountExpirationTime']);
};

SJ.playerData.incrementDailyJumpsCount = () => {
	if (SJ.playerData.data['name'] !== 'Guest') {
		const tournamentName = SJ.tournament ? SJ.tournament.name : 'false';
		let jumpsCountType = '';

		if (tournamentName !== 'false')
			jumpsCountType = 'tournamentDailyJumpsCount';
		else jumpsCountType = 'worldcupDailyJumpsCount';

		SJ.playerData.data[jumpsCountType]++;

		fetch(
			`${SJ.APILink}user/updateJumpsCount.php?userName=${SJ.playerData.data['name']}&counterType=${jumpsCountType}`
		);
	}
};

SJ.playerData.checkIfPaymentNotifications = () => {
	fetch(
		`${SJ.APILink}shop/checkSuccessNotification.php?userName=${SJ.playerData.data['name']}`
	)
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			if (res != 'No notifications to show') {
				SJ.showPaymentNotification = true;
			}
		});
};

SJ.playerData.updatePlayerRankPosition = (callback = null) => {
	fetch(
		`${SJ.APILink}user/getRankPosition.php?rankType=mapGlobalRankingScore&userName=${SJ.playerData.data['name']}`
	)
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			SJ.playerData.data['mapGlobalRankingPosition'] = res;

			fetch(
				`${SJ.APILink}user/getRankPosition.php?rankType=tournamentRankingScore&userName=${SJ.playerData.data['name']}`
			)
				.then((res) => {
					return res.json();
				})
				.then((res) => {
					SJ.playerData.data['tournamentRankingPosition'] = res;

					if (callback) callback();
				});
		});
};
